export default {"src":"/_next/static/media/matic.6f9cf474.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};